var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 22.503,
    viewBox: "0 0 30 22.503",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3312",
    "data-name": "Group 3312",
    transform: "translate(-476.843 -3261.275)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3311",
    "data-name": "Group 3311"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3195",
    "data-name": "Path 3195",
    d: "M506.843,3265.379v16.171a1.357,1.357,0,0,0-.045.137,2.484,2.484,0,0,1-2.55,2.088q-12.4.006-24.812-.009a2.857,2.857,0,0,1-1.182-.265,2.407,2.407,0,0,1-1.409-2.341q-.006-7.719,0-15.438a1.66,1.66,0,0,1,.008-.234.62.62,0,0,1,.955-.446,1.981,1.981,0,0,1,.23.18q4.68,3.992,9.358,7.985c1,.85,1.969,1.724,2.978,2.555a2.284,2.284,0,0,0,1.731.477,3.207,3.207,0,0,0,1.781-.929q5.877-5.047,11.763-10.085C506.153,3264.792,506.482,3264.838,506.843,3265.379Z",
    fill: "#8a8a8a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3196",
    "data-name": "Path 3196",
    d: "M491.843,3261.277q6.182,0,12.363,0a2.559,2.559,0,0,1,1.925.771c.426.438.4.786-.064,1.185-2.046,1.738-4.1,3.471-6.137,5.218q-3.535,3.031-7.056,6.081a1.316,1.316,0,0,1-2.061,0q-6.583-5.641-13.171-11.279c-.5-.43-.52-.783-.046-1.247a2.565,2.565,0,0,1,1.884-.729Q485.662,3261.283,491.843,3261.277Z",
    fill: "#8a8a8a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSms);
export default __webpack_public_path__ + "static/media/sms.2d8ecb44401849047c33f5b95076e445.svg";
export { ForwardRef as ReactComponent };